import Vue from "vue";
import VueRouter from "vue-router";
import { PAGES } from "@/enums/pages";

Vue.use(VueRouter);

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem("token")) {
    next();
    return;
  }
  router.push({
    name: 'intro',
  });
};

const isAuthenticated = (to, from, next) => {
  if (!localStorage.getItem("token")) {
    next();
    return;
  }
  router.push({
    name: 'home',
  });
};

const routes = [
  {
    path: "/",
    name: "intro",
    component: () => import(
      /* webpackChunkName: "home" */"../components/pages/IntroPage/IntroPage.vue"
    ),
    beforeEnter: isAuthenticated,
  },
  {
    path: "/login",
    name: "login",
    component: () => import(
      /* webpackChunkName: "home" */"../components/pages/LoginPage/LoginPage.vue"
    ),
    beforeEnter: isAuthenticated,
  },
  {
    path: "/login-choose-instance",
    name: "choose-instance",
    component: () => import(
      /* webpackChunkName: "home" */"../components/pages/LoginPage/LoginInstancePage.vue"
    ),
    auth: true
  },
  {
    path: "/home",
    redirect: '/simulator',
    name: "home",
    component: () => import(
      /* webpackChunkName: "home" */"../components/pages/HomePage/HomePage.vue"
    ),
    children: [
      // Simulador
      {
        path: '/simulator',
        name: PAGES.SIMULATOR,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/SimulatorPage/SimulatorPage.vue"
        ),
        auth: true
      },
      // Backoffice
      {
        path: '/backoffice/users',
        name: PAGES.BACKOFFICE_USERS,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/BackofficeUsers/BackofficeUsers.vue"
        ),
        auth: true
      },
      {
        path: '/backoffice/users-group',
        name: PAGES.BACKOFFICE_USERS_GROUP,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/BackofficeUsersGroup/BackofficeUsersGroup.vue"
        ),
        auth: true
      },
      {
        path: '/backoffice/user/:id?',
        name: PAGES.BACKOFFICE_USER_DETAIL,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/UserDetails/UserDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/user/edit/:id?',
        name: PAGES.BACKOFFICE_USER_DETAIL_EDIT,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/UserDetails/UserDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/companies/points-of-sale',
        name: PAGES.BACKOFFICE_ENTITIES,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/BackofficeEntities/BackofficeEntities.vue"
        ),
        auth: true
      },
      {
        path: '/backoffice/point-of-sale/:id?',
        name: PAGES.BACKOFFICE_ENTITY_DETAIL,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/EntityDetails/EntityDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/point-of-sale/view/:id?',
        name: PAGES.BACKOFFICE_VIEW_ENTITY_DETAIL,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/EntityDetails/EntityDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/companies',
        name: PAGES.BACKOFFICE_COMPANIES,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/BackofficeCompanies/BackofficeCompanies.vue"
        ),
        auth: true
      },
      {
        path: '/backoffice/company/:id?',
        name: PAGES.BACKOFFICE_COMPANY_DETAIL,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/CompanyDetails/CompanyDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/company/edit/:id?',
        name: PAGES.BACKOFFICE_COMPANY_DETAIL_EDIT,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/CompanyDetails/CompanyDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financials',
        name: PAGES.BACKOFFICE_FINANCIALS,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/BackofficeFinancials/BackofficeFinancials.vue"
        ),
        auth: true
      },
      {
        path: '/backoffice/financial/:id/instance/:idInstance?',
        name: PAGES.BACKOFFICE_FINANCIAL_DETAIL,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/FinancialDetails/FinancialDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial/edit/:id/instance/:idInstance?',
        name: PAGES.BACKOFFICE_FINANCIAL_DETAIL_EDIT,
        component: () => import(
            /* webpackChunkName: "home" */"../components/pages/FinancialDetails/FinancialDetails.vue"
            ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial/:id?/instance/:idInstance?/spread',
        name: PAGES.BACKOFFICE_FINANCIAL_DETAIL_SPREAD,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/FinancialDetails/SpreadDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial/:id?/instance/:idInstance?/insurances',
        name: PAGES.BACKOFFICE_FINANCIAL_DETAIL_INSURANCES,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/FinancialDetails/InsuranceDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/insurances',
        name: PAGES.BACKOFFICE_INSURANCES,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/BackofficeInsurances/BackofficeInsurances.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial/:id?/instance/:idInstance?/tins',
        name: PAGES.BACKOFFICE_FINANCIAL_DETAIL_TIN,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/FinancialDetails/FinancialTINDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial/:idFinancial?/instance/:idInstance?/disclaimer/:idDisclaimer?',
        name: PAGES.BACKOFFICE_FINANCIAL_DETAIL_DISCLAIMER,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/FinancialDetails/DisclaimerDetails.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/sites/rate-of-sites',
        name: PAGES.BACKOFFICE_RATE_SITES,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/BackofficeRatesSite/BackofficeRatesSite.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial-data/taeg',
        name: PAGES.BACKOFFICE_FINANCIAL_DATA_TAEG,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/BackofficeFinancialData/TAEG/TAEG.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial-data/iscd',
        name: PAGES.BACKOFFICE_FINANCIAL_DATA_ISCD,
        component: () => import(
            /* webpackChunkName: "home" */"../components/pages/BackofficeFinancialData/ISCD/ISCD.vue"
            ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial-data/iscd/details/:idProduct/:idClient?',
        name: PAGES.BACKOFFICE_FINANCIAL_DATA_ISCD_DETAIL,
        component: () => import(
            /* webpackChunkName: "home" */"../components/pages/BackofficeFinancialData/ISCD/ISCDTable/ISCDTable.vue"
            ),
        auth: true,
        props: true
      },
      {
        path: '/backoffice/financial-data/transversal',
        name: PAGES.BACKOFFICE_FINANCIAL_DATA_TRANSVERSAL,
        component: () => import(
            /* webpackChunkName: "home" */"../components/pages/BackofficeFinancialData/Transversal/Transversal.vue"
            ),
        auth: true,
        props: true
      },
      // Cotação
      {
        path: '/cotation',
        name: PAGES.COTATION,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/CotationPage/CotationPage.vue"
        ),
        auth: true
      },
      // Propostas
      {
        path: '/proposals',
        name: PAGES.PROPOSAL_LIST_PROPOSAL,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/ProposalsPage/ProposalsListPage.vue"
        ),
        auth: true
      },
      {
        path: '/proposal/:id?',
        name: PAGES.PROPOSAL_PAGE,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/ProposalPage/ProposalPage.vue"
        ),
        auth: true,
        props: true
      },
      {
        path: '/error',
        name: PAGES.ERROR_PAGE,
        component: () => import(
          /* webpackChunkName: "home" */"../components/pages/ProposalErrorPage/ProposalErrorPage.vue"
        ),
        auth: true
      }
    ],
    beforeEnter: ifAuthenticated,
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes,
});

export default router;
